module.exports = __webpack_public_path__ + "img/sqrql_logo.b2f0098d.png";